export default "/images/vendor/flag-icon-css/flags/4x3/tg.svg?f97c4ebe662df8683fdec11f56c87599";